// extracted by mini-css-extract-plugin
export var coverSection = "Cover-module--coverSection--Y9-IL";
export var coverVector = "Cover-module--coverVector--zLSDY";